import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Icon from 'Components/UI/Icon';
import HeaderActions from 'Components/UI/HeaderActions';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MuiDrawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import List from '@material-ui/core/List';
import { isHidden } from 'Components/UI/Navigation/utils';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useUserContext from 'Context/UserContext';
import useHomeContext from 'Context/HomeContext';
import useEventTrackingLogEvent, { eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import NavItem from './Item';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    zIndex: theme.zIndex.drawer + 1,
    height: theme.heights.clientNavigationHeight,
    backgroundColor: theme.palette.common.white,
  },
  drawerHeader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  drawerPaper: {
    flexDirection: 'column',
    alignItems: 'center',
    height: '100vh',
  },
});

const MobileNavigation = ({ classes, className, schema }) => {
  const { householdResource } = useSimpleHousehold();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { userResource, agentResource } = useUserContext();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { MobileSearchComponent } = schema;
  const { homeResource } = useHomeContext();

  const onNavItemClick = (navItem) => {
    if (navItem.logEvent) {
      logStandardizedEvent(navItem.eventLoggingCategory,
        eventTypes.navigateTo,
        `${navItem.label} -  Navigated to ${navItem.label} via left nav bar on mobile`);
    }
    if (navItem.to) {
      setDrawerOpen(false);
    }
  };


  return (
    <>
      <AppBar
        position="fixed"
        className={classNames(classes.root, className)}
      >
        <IconButton
          aria-label="open drawer"
          onClick={() => setDrawerOpen(true)}
          test={'mobile-navigation-drawer-button'}
        >
          <MenuIcon />
        </IconButton>
        {(MobileSearchComponent) ? <MobileSearchComponent /> : null}
        <HeaderActions />
      </AppBar>
      <MuiDrawer
        anchor="top"
        classes={{
          paper: classes.drawerPaper,
        }}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <div className={classes.drawerHeader}>
          <IconButton
            className={classes.closeButton}
            onClick={() => setDrawerOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <Icon icon="facetLogo" width="155px" height="100px" />
        <List>
          {
            schema.navigationItems.filter(isHidden({
              householdResource, userResource, agentResource, homeResource,
            })).map(navItem => (
              <NavItem
                id={navItem.id}
                key={navItem.key}
                isMobileItem
                onClick={() => onNavItemClick(navItem)}
                {...navItem}
              />
            ))
          }
        </List>
      </MuiDrawer>
    </>
  );
};

MobileNavigation.defaultProps = {
  className: '',
};

MobileNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  schema: PropTypes.object.isRequired,
};

export default withStyles(styles)(MobileNavigation);
